<div>
  <app-h *ngIf="header" [type]="headerType" [subtitle]="header" [id]="id"></app-h>
  <p [innerHTML]="data || '' | translate" [ngClass]="size === 'large' ? 'cm-paragraph-large' : 'cm-paragraph'"></p>
</div>
